import React, { useRef } from "react";
import { API_ROOT } from "../../services/api";

const LoginForm = ({
  handleUserLogin,
  forgotPasswordName,
  showRegistrationForm,
  error,
  registrationSuccess,
}) => {
  const emailInput = useRef(null);
  const passwordInput = useRef(null);
  const onSubmitForm = (e) => {
    e.preventDefault();

    const data = {
      email: emailInput?.current?.value,
      password: passwordInput?.current?.value,
      name: emailInput?.current?.value,
    };

    handleUserLogin(data);
  };

  return (
    <div>
      <h3 className="login-prompt__header">
        Please login to save your design.
      </h3>

      {error && (
        <p className="upload__login-error">
          Login unsuccessful. Please confirm your email and password and try
          again.
        </p>
      )}

      {registrationSuccess && (
        <p className="upload__login-success">
          Registration successful! Please login below.
        </p>
      )}

      <div className="login-prompt__form">
        <form action="" onSubmit={onSubmitForm}>
          <div className="upload__input">
            <input
              type="text"
              name="email"
              ref={emailInput}
            />
            <label>Email</label>
          </div>

          <div className="upload__input">
            <input
              type="password"
              name="password"
              ref={passwordInput}
            />
            <label>Password</label>
          </div>

          <div className="upload__forgot-pass">
            <a href={`${API_ROOT}/user/password${forgotPasswordName}`}>
              Forgot password?
            </a>{" "}
            |
            <span
              className="link link--register"
              onClick={showRegistrationForm}
            >
              Create an account
            </span>
          </div>

          <button
            className="button button--round button--login-prompt"
            type="submit"
          >
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
